import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "./axiosConfig";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch settings from the server
  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.post("/settings/get/object", {});
      setSettings(response.data.data);
    } catch (err) {
      console.error("Error fetching settings:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, error }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
